import { ConversationTag, GetConversationTagsPaginationData } from '../typings';
import { createPaginatedRequestAtom, createRequestAtom } from '../../../../shared/utils/request-atom';

export const conversationTagsAtom = createRequestAtom<ConversationTag[]>();

export const paginatedConversationTagsAtom = createPaginatedRequestAtom<
  ConversationTag,
  GetConversationTagsPaginationData
>({
  loading: false,
});

export const paginatedFiltersConversationTagsAtom = createPaginatedRequestAtom<
  ConversationTag,
  GetConversationTagsPaginationData
>({
  loading: false,
});

export const paginatedFiltersConversationTagsOriginalAtom = createPaginatedRequestAtom<
  ConversationTag,
  GetConversationTagsPaginationData
>({
  loading: false,
});

export const paginatedFiltersConversationTagsSearchAtom = createPaginatedRequestAtom<
  ConversationTag,
  GetConversationTagsPaginationData
>({
  loading: false,
});
